export function V2OpportunitySlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row gap-12">
        <div className="flex-1 flex flex-col justify-start">
          <h2 className="text-[32px] font-light tracking-tight mb-3 font-[family-name:var(--font-heading)]">
            AI capability is exploding.<br />Adoption is not.
          </h2>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-4">
            AI agents can now automate entire professional workflows. But regulated industries have <strong className="font-medium text-[var(--color-fg)]">near-zero adoption</strong>. Not because the technology doesn&apos;t work. Because it isn&apos;t <strong className="font-medium text-[var(--color-fg)]">trustworthy enough</strong>.
          </p>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
            Regulated firms have <strong className="font-medium text-[var(--color-fg)]">zero tolerance for error</strong>. But AI has no ground truth to work from. The only way to close that gap is with <strong className="font-medium text-[var(--color-fg)]">real operational data</strong>: ground-truth baselines that <strong className="font-medium text-[var(--color-fg)]">define correct</strong>, so agents can be measured and improved against it.
          </p>
        </div>

        <div className="w-[35%] shrink-0 flex items-start relative pt-0">
          <div className="flex flex-col justify-start w-full pl-10 -my-4 py-4 gap-6 border-l border-[var(--color-border)]">
            {[
              { value: (<>63%<sup className="text-[16px] align-super">1</sup></>), label: "Vertical AI agent CAGR" },
              { value: (<>$50B<sup className="text-[16px] align-super">2</sup></>), label: "Global AI agent market by 2030" },
              { value: (<>&lt; 5%<sup className="text-[16px] align-super">3</sup></>), label: "AI agents in regulated workflows" },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-[36px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
                  {stat.value}
                </div>
                <div className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
            <div className="text-[8px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] opacity-50 leading-relaxed">
              Source: ¹MarketsandMarkets 2025 ²BCC Research 2026 ³Industry estimates
            </div>
          </div>
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Most AI companies sell software and hope firms adopt it.
        </p>
        <p className="text-[12px] font-medium text-[var(--color-fg)] mt-0.5">
          COSX takes a different approach: acquire the firms, deploy agents from the inside, and use real operational data to make those agents measurably better.
        </p>
      </div>
    </div>
  );
}
